function scrollToAccordion(id) {
  const accordion = document.getElementById(id);

  if (accordion && accordion.offsetParent === null) return;

  const clientRects = accordion.getBoundingClientRect();
  const rawHeaderHeight = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height');
  const headerHeight = parseInt(rawHeaderHeight.substring(0, rawHeaderHeight.length -2));

  window.scrollTo({
    top: window.scrollY + clientRects.y - headerHeight,
    behavior: "smooth"
  });

  setTimeout(() => {
      const clientRects = accordion.getBoundingClientRect();
      const headerHeight = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height').substring(-2));

      window.scrollTo({
        top: window.scrollY + clientRects.y - headerHeight,
        behavior: "smooth"
      });
    }, 301
  )
}
